import React, {useMemo, useRef} from 'react';

import {LoadableView} from '../../../state/views/types';
import {
  getWorkspaceDisplayName,
  WORKSPACE_PLACEHOLDER_NAME,
} from '../../../state/workspaces/namedWorkspaceActionsInternal';
import {isUnnamedWorkspace} from '../utils';
import {
  EditableNamedWorkspaceLabel,
  NamedWorkspaceLabel,
} from './NamedWorkspaceLabel';

type NamedWorkspaceDisplayNameProps = {
  currentView: LoadableView | undefined;
  displayName: string;
  isRenameAllowed: boolean;
  isRenaming: boolean;
  setIsRenaming: (isRenaming: boolean) => void;
};
export const NamedWorkspaceDisplayName = ({
  displayName,
  currentView,
  isRenameAllowed,
  isRenaming,
  setIsRenaming,
}: NamedWorkspaceDisplayNameProps) => {
  // Use set the initial input width in the Label because the
  // NamedWorkspaceLabel gets dismounted when renaming begins.
  const wokspaceDisplayNameRef = useRef<HTMLInputElement | null>(null);
  const initialInputWidth = useMemo(() => {
    return wokspaceDisplayNameRef?.current?.clientWidth;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wokspaceDisplayNameRef, isRenaming]);

  if (isRenaming) {
    return (
      <EditableNamedWorkspaceLabel
        initialInputWidth={initialInputWidth}
        setIsRenaming={setIsRenaming}
      />
    );
  }

  return (
    <NamedWorkspaceLabel
      displayName={
        isUnnamedWorkspace(displayName)
          ? WORKSPACE_PLACEHOLDER_NAME
          : getWorkspaceDisplayName(currentView)
      }
      wokspaceDisplayNameRef={wokspaceDisplayNameRef}
      isRenameAllowed={isRenameAllowed}
      setIsRenaming={setIsRenaming}
    />
  );
};
